import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MobileSidebar from 'widgets/MobileSidebar/MobileSidebar';
import NavigationMenuHeader from './NavigationMenuHeader';
import NavigationMenuContent from '../containers/NavigationMenuContent';

export default class NavigationMenu extends Component {
  static propTypes = {
    closeMobileNav: PropTypes.func.isRequired,
    navMenuLevel: PropTypes.string.isRequired,
    opened: PropTypes.bool.isRequired,
    sections: PropTypes.array,
  };

  shouldComponentUpdate(nextProps) {
    if (!nextProps.opened && !this.props.opened) {
      return false;
    }

    return (
      this.props.opened !== nextProps.opened
      || this.props.sections !== nextProps.sections
      || this.props.navMenuLevel !== nextProps.navMenuLevel
    );
  }

  render() {
    const { opened, sections, navMenuLevel } = this.props;
    return (
      <div className="navigation-menu-wrapper">
        <MobileSidebar
          isOpen={opened}
          onClose={this.props.closeMobileNav}
        >
          <nav
            className="navigation-menu"
            id="navigation-menu"
          >
            <NavigationMenuHeader navMenuLevel={navMenuLevel} />
            <NavigationMenuContent sections={sections} />
            <div className="navigation-bottom" />
          </nav>
        </MobileSidebar>
      </div>
    );
  }
}
